let boundCards = [];	
	
function bindThirdParty() {
	document.querySelectorAll('.pers-feed-item.thirdp').forEach(element => {
		if (boundCards.indexOf(element.getAttribute('data-id')) == -1) {
			boundCards.push(element.getAttribute('data-id'));
			
			element.querySelector('.pers-third-party-view-summary').addEventListener('click', function(e) {
				element.classList.add('active');
				wmdPageLink('fy-thrd_more', this);
			});
			
			element.querySelector('.pers-third-party-view-less').addEventListener('click', function(e) {
				element.classList.remove('active');
				wmdPageLink('fy-thrd_less', this);
			});
			
		}
	});
}

document.addEventListener('feedLoaded', bindThirdParty);